<template>
  <v-app>
    <component :is="layout">
      <transition name="fade">
        <router-view v-if="initialized" />
      </transition>
    </component>
    <snack-bar />
    <loader v-if="loading.state" />
  </v-app>
</template>

<script>
import SnackBar from '../components/snackbar'
import Loader from '../components/loader'
import { mapGetters, mapActions } from 'vuex'
const default_layout = 'default'
export default {
  name: 'App',
  components: {
    SnackBar,
    Loader
  },
  data: () => ({
    initialized: false
  }),
  computed: {
    ...mapGetters({
      loading: 'general/loading',
      user: 'general/user'
    }),
    layout() {
      return (this.$route.meta.layout || default_layout) + '-layout'
    }
  },
  watch: {},
  async mounted() {
    if (this.$route.meta.auth) {
      // Set user profile
      await this.init()
    }
    this.initialized = true
  },
  methods: {
    ...mapActions({
      init: 'general/initialize'
    })
  }
}
</script>
